import React, { useState } from "react";
import "../styles/productImage.css";

/**
 * Renders a real product screenshot/diagram from src/assets.
 * If the underlying file hasn't been swapped in yet (or fails to load),
 * falls back to a clean placeholder frame instead of a broken image icon —
 * safe to ship before real screenshots are dropped into the asset folders.
 */
function ProductImage({ src, alt, frame = "device", className = "" }) {
  const [errored, setErrored] = useState(false);

  return (
    <div className={`product-image product-image--${frame} ${className}`}>
      {!errored ? (
        <img src={src} alt={alt} loading="lazy" onError={() => setErrored(true)} />
      ) : (
        <div className="product-image-fallback" role="img" aria-label={alt}>
          <span>{alt}</span>
        </div>
      )}
    </div>
  );
}

export default ProductImage;
